const SET_PREVIEW = "SET_PREVIEW";
const SET_LAST_SELECTED_ENTITY_TYPES = "SET_LAST_SELECTED_ENTITY_TYPES";
const SET_LOADING = "SET_LOADING";
const SET_ERROR = "SET_ERROR";
const SET_BITRIX_AUTH = "SET_BITRIX_AUTH";
const SET_IS_BITRIX = "SET_IS_BITRIX";
const SET_BITRIX_LINKED = "SET_BITRIX_LINKED";
const SET_BITRIX_CONNECTION_VALID = "SET_BITRIX_CONNECTION_VALID";

export {
  SET_PREVIEW,
  SET_LAST_SELECTED_ENTITY_TYPES,
  SET_LOADING,
  SET_ERROR,
  SET_BITRIX_AUTH,
  SET_IS_BITRIX,
  SET_BITRIX_LINKED,
  SET_BITRIX_CONNECTION_VALID,
};
